import { memo } from 'react'
import type { AgentLog } from '../../types'
import { formatLogTime, levelColorClass, normalizeLevel } from '../../lib/agentLogFormat'

/** One console line: `[HH:MM:SS.mmm] LEVEL/TAG: message`. memo'd — the console
 * re-renders often (live polling) but individual lines are immutable. */
export const LogLine = memo(function LogLine({ log }: { log: AgentLog }) {
  return (
    <div
      data-log-id={log.id}
      className={`whitespace-pre-wrap break-words ${levelColorClass(log.level)}`}
    >
      {/* Shows the device clock (logged_at) — what the operator usually wants —
          but rows are ordered by server created_at, so on a skewed device the
          visible times can be non-monotonic. The authoritative ingest time is in
          the tooltip. */}
      <span className="text-gray-500" title={`server: ${formatLogTime(log.created_at)}`}>
        [{formatLogTime(log.logged_at)}]
      </span>{' '}
      <span className="font-semibold">
        {normalizeLevel(log.level)}/{log.tag}
      </span>
      : {log.message}
    </div>
  )
})
